export enum CurrencyPosition {
  START = "start",
  END = "end",
}
